import { useEffect } from 'react';
import { useCheckUserFollowsCoachLazyQuery } from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';

interface UseIsFollowingCoachProps {
  coachId: string;
  initialUserId?: string;
}

const useIsFollowingCoach = ({ coachId, initialUserId }: UseIsFollowingCoachProps) => {
  const viewer = useViewer();
  const userId = viewer.userId || initialUserId;

  const [checkUserFollowsCoachLazyQuery, { data, loading, error }] =
    useCheckUserFollowsCoachLazyQuery();

  const isFollowing = Boolean(data?.userFollows?.length);
  const follower = data?.userFollows?.[0] || null;

  useEffect(() => {
    if (coachId && userId) {
      checkUserFollowsCoachLazyQuery({
        variables: {
          coachId,
          userId,
        },
      });
    }
  }, [checkUserFollowsCoachLazyQuery, userId, coachId]);

  return { isFollowing, follower, loading, error };
};

export default useIsFollowingCoach;
